module.exports = __webpack_public_path__ + "static/media/12UNCTAD2.52981f1f.jpg";